import * as React from "react";
export const BookIcon = ({ ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M20,3H4C2.897,3,2,3.897,2,5v14c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V5C22,3.897,21.103,3,20,3z M19,7v2h-5V7H19z M14,11h5v2h-5V11z M4,19V5h7v14H4z" />
  </svg>
);
